import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography, Row, Col, DatePicker, Spin, message, Checkbox } from "antd";
import { LeftOutlined, RightOutlined ,ArrowRightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import PhoneInput from "react-phone-input-auto-format";
import AlphabetInput from "../../components/AlphabetInput";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import moment from "moment";
import _BankAdminService from "../../modules/BankAdminService";
import SidebarLayout from "../BankerUI/SidebarLayout";
import "./BankAdminProfile.scss";
import FormItemAlphabetInput from "../../components/FormItems/FormItemAlphabetInput";
import ButtonComponent from "../../components/Button/Button";
const { Title } = Typography;



const BankAdminPersonalDetails = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const BankerId = localStorage.getItem("BankAdminId");
    const [personalInfo, setPersonalInfo] = useState({});
    const [form] = Form.useForm();
    const location = useLocation();
    let data = location.state;
    let BankerIdFromProfile = "";
    let fromDashboard = false;

    if (data && data.BankerId) {
        BankerIdFromProfile = data.BankerId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    const [BankerFromProfileID] = useState(BankerIdFromProfile);
    const [isFromDashboard] = useState(fromDashboard);


    useEffect(() => form.resetFields(), [personalInfo]);
    useEffect(() => {
        getpersonalDetailsById();
    }, []);

    const onFinish = async (values) => {
        const midadleFirstLetter = values.middleInitial || "";
        try {
            setLoading(true)
            const reqObj = {
                Id: BankerFromProfileID ? BankerFromProfileID : BankerId,
                ScreenName: "personaldetails",
                FirstName: values.firstName,
                MiddleInitial: midadleFirstLetter != "" ? midadleFirstLetter : null,
                LastName: values.lastName,
                DateOfBirth: values.dob ? moment(values.dob).format("YYYY-MM-DD") : null,
                ContactNumber: values.contactNumber,
                IsSSOLogin: values.isSSOLogin === true,
            }
            const res = await _BankAdminService.UpdateBankAdminData(reqObj);
            if (res.data.IsSuccess) {
                localStorage.setItem("BankAdminFirstName", values.firstName);
                setLoading(false);
                if (isFromDashboard) {
                    history.push({ pathname: routes.bankadminprofile.path, state: { BankerId, } });
                } else {
                    history.push(routes.bankadminprofessionaldetails.path);
                }
                message.success(res.data.Message)
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.log(err);
            setLoading(false)
        }
    };

    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.bankadminprofile.path, state: { BankerId, } });
        } else {
            history.push(routes.createNewPasswordForBanker.path);
        }
    }
    const getpersonalDetailsById = async () => {
        const resObj = await _BankAdminService.getBankAdminInformationByBankAdminId(BankerFromProfileID ? BankerFromProfileID : BankerId);
        if (resObj.data) {
            const res = resObj.data.Obj;
            setPersonalInfo({
                applicationType: res.FirstName,
                firstName: res.FirstName,
                middleInitial: res.MiddleInitial,
                lastName: res.LastName,
                dob: res.DateOfBirth ? moment(res.DateOfBirth) : null,
                contactNumber: res.ContactNumber,
                isSSOLogin: res.IsSSOLogin === true,
            });
        }

    }

    const disableFutureDates = (current) => {
        return current && current > moment().startOf("day");
    };

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                <div className="form-container card-section">
                    <Title level={2} className="page-title" style={{ marginBottom: 24 }}>
                        Personal Details
                    </Title>
                    <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={true}
                        initialValues={personalInfo}
                    >

                        <Row gutter={16} className="">
                            <Col span={8} >
                                <FormItemAlphabetInput
                                    label="First Name"
                                    name="firstName"
                                    placeholder="Enter First Name"
                                    rules={[{ required: true, message: "First Name is required" }]}
                                    maxLength={30}
                                />
                                {/* <Form.Item
                                    label="First Name"
                                    name="firstName"
                                    rules={[{ required: true, message: "First Name is required" }]}
                                >
                                    <AlphabetInput placeholder="Enter First Name" maxLength={30} />
                                </Form.Item> */}
                            </Col>
                            <Col span={8}>
                                <FormItemAlphabetInput
                                    label="Middle Name"
                                    name="middleInitial"
                                    placeholder="Enter Middle Name"
                                    maxLength={30}
                                // rules={[
                                //     { required: true, max: 1, message: "Only one character allowed" },
                                // ]}
                                />

                                {/* <Form.Item
                                    label="Middle Initial"
                                    name="middleInitial"
                                    // rules={[
                                    //     { required: true, max: 1, message: "Only one character allowed" },
                                    // ]}
                                >
                                    <AlphabetInput placeholder="Enter Middle Initial" maxLength={1} />
                                </Form.Item> */}
                            </Col>
                            <Col span={8}>
                                <FormItemAlphabetInput
                                    label="Last Name"
                                    name="lastName"
                                    placeholder="Enter Last Name"
                                    rules={[{ required: true, message: "Last Name is required" }]}
                                    maxLength={30}
                                />
                                {/* <Form.Item
                                    label="Last Name"
                                    name="lastName"
                                    rules={[{ required: true, message: "Last Name is required" }]}
                                >
                                    <AlphabetInput placeholder="Enter Last Name" maxLength={30} />
                                </Form.Item> */}
                            </Col>
                        </Row>
                        <Row gutter={16} className="">
                            <Col span={12}>
                                <Form.Item
                                    label="Date Of Birth"
                                    name="dob"
                                    rules={[{ required: true, message: "Date Of Birth is required" }]}
                                >
                                    <DatePicker
                                        allowClear
                                        inputReadOnly={false}
                                        style={{ width: "100%" }}
                                        format="MM/DD/YYYY"
                                        placeholder="MM/DD/YYYY"
                                        disabledDate={(current) => {
                                            return current && current >= moment().startOf("day");
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>

                                <Form.Item
                                    label="Contact Number"
                                    name="contactNumber"
                                    rules={[
                                        { required: true, message: "Contact Number is required" },
                                        {
                                            validator: (_, value) => {
                                                if (!value) {
                                                    return Promise.resolve(); //  Allow empty value if not required
                                                }
                                                const digits = value.replace(/\D/g, '');
                                                if (digits.length === 10) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(
                                                    new Error("Wrong format! please use this format (XXX) XXX-XXXX")
                                                );
                                            },
                                        }
                                    ]}
                                >
                                    <PhoneInput
                                        placeholder="Enter Contact Number"
                                        inputComponent={Input}
                                        autoComplete="off"
                                        onChange={(value) => {
                                            // Remove non-digit characters and store the raw number
                                            const digits = value.replace(/\D/g, '');
                                            form.setFieldsValue({ contactNumber: digits });
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16} className="">
                            <Col span={12}>
                                <Form.Item name="isSSOLogin" valuePropName="checked" initialValue={false}>
                                    <Checkbox>SSO Login</Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item className="rightsection">
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginTop: 20 }}>
                                {/* <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                >
                                    Go Back
                                </Button> */}
                                <ButtonComponent
                                    text={
                                        <span>
                                            Save And Proceed <ArrowRightOutlined />
                                        </span>
                                    }
                                    // text="Save And Proceed"
                                    htmlType="submit"
                                    type="primary"
                                />
                                {/* <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button> */}
                            </div>
                        </Form.Item>
                    </Form>

                </div>
            </LeftLayout>
        </Spin>
    );
};

export default BankAdminPersonalDetails;
